import React, { Component } from 'react'
import PropTypes from 'prop-types'

import serialize from 'form-serialize'
import some from 'lodash/some'
import get from 'lodash/get'
import flatten from 'lodash/flatten'
import isEqual from 'lodash/isEqual'

export default class Form extends Component {

  static propTypes = {
    onData: PropTypes.func.isRequired,
    validations: PropTypes.array
  }

  static defaultProps = {
    validations: []
  }
  
  state = {
    saving: false,
    saved: false,
    problems: []
  }
  
  componentDidUpdate(prevProps, prevState) {
    // If there is a new success message upon form submission,
    // scroll down to the message so that it is in full view.
    if (!!this.successMessage && !prevState.saved) {
      this.successMessage.scrollIntoView()
    }
    
    // If there is a new error message, scroll down to the
    // message so that it is in full view.
    if (!isEqual(prevState.problems, this.state.problems)) {
      if (this.errorMessage) {
        this.errorMessage.scrollIntoView()
      }
    }
    
    // Highlight fields that have errors in them
    for (let problem of this.state.problems) {
      const input = document.querySelector(`input[name=${problem.field}]`)
      if (input) input.classList.add('field-error')
    }
    
    // Remove all error highlighting when there are no more
    // fields with problems
    if (!this.state.problems.length) {
      const inputs = document.querySelectorAll('input')
      inputs.forEach((input) => input.classList.remove('field-error'))
    }
  }

  process = () => {
    const data = serialize(this.form, { hash: true })
    const problems = this.validate(data)

    return {
      data, problems
    }
  }

  submitHandler = (event) => {
    event.preventDefault()
    
    const { data, problems } = this.process()
    const { onData } = this.props
    
    this.setState({ saved: false, problems }, () => {
      if (!this.state.problems.length) {
        this.setState({ saving: true })
        onData(data).then(
          // FIXME it's possible the component has unmounted before this promise resolves
          // e.g. The create a search form goes back to the `return_to` if set.
          () =>    this.setState({ saving: false, saved: true }),
          error => {
            let problems
            const errors = error.response && error.response.data && error.response.data.errors
            if (errors) {
              const fields = Object.keys(errors)
              problems = flatten(fields.map(field => errors[field].map(msg => field === 'base' ? msg : `${field} ${msg}`)))
            } else {
              problems = [`${error}`]
            }
            this.setState({ saving: false, problems })
          }
        )
      }
    })
  }

  validate(data) {
    const { validations } = this.props
    const problems = []

    if (!validations) return problems

    validations.forEach(({ field, validate, message }) => {
      const validators = Array.isArray(validate) ? validate : [validate]
      const invalid = some(validators, validator => validator(get(data, field)))
      if (invalid) problems.push({ message, field })
    })

    return problems
  }

  getProblems() {
    const { problems } = this.state
    if (problems.length) {
      return (
        <ul className="error" ref={el => this.errorMessage = el}>
          <h3>There was a problem saving these settings:</h3>
          {problems.map((problem,i) => <li key={`${problem.message}-${i}`}>{problem.message}</li> )}
        </ul>
      )
    }
  }

  render() {
    const { validations, onData, ...props }= this.props
    const { saving, saved } = this.state

    return (
      <form ref={el => this.form = el} {...props} onSubmit={this.submitHandler}>
        {this.props.children}
        {this.getProblems()}
        {saving && <div className="panel padded saving">Saving...</div>}
        {saved && <div className="panel padded saved" ref={el => this.successMessage = el}>Saved!</div>}
      </form>
    )
  }

}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/index.js